import { useEffect, useState, useRef } from 'react'
import { useForm } from 'react-hook-form'
import { SystemLogsQuery, useMountpointsList, useSystemLogs } from '../api'
import { keys } from 'lodash'
import { AutoSizer, List } from 'react-virtualized'

import GridContainer from 'common/Grid/GridContainer'
import GridItem from 'common/Grid/GridItem'
import DateInput from 'common/inputs/DateInput'
import SelectInput from 'common/inputs/SelectInput'
import TextInput from 'common/inputs/TextInput'

import TimePicker from 'react-multi-date-picker/plugins/time_picker'
import DateObject from 'react-date-object'

import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
// import CircularProgress from '@material-ui/core/CircularProgress'

import { formatDate } from '../format-helpers'

import { COUNT_OPTIONS } from './constants'
import { strings } from 'strings'
import useStyles from './styles'
import LogsList from './LogsList'

export function LogViewer() {
  const classes = useStyles()
  const DATE_FORMAT = 'YYYY/MM/DD HH:mm:ss'
  const defaultDate = new DateObject()
    .setHour(new Date().getHours() - 1)
    .setMinute(0)
    .setSecond(0)

  const { control, handleSubmit } = useForm()

  const [logsQuery, setLogsQuery] = useState<SystemLogsQuery>()
  const [strLogs, setStrLogs] = useState<string[]>([])
  const [logs, setLogs] = useState<any[]>([])
  // const [loading, setLoading] = useState(false)

  const filterRef = useRef<HTMLInputElement>(null)
  /**Filter by table columns content */
  const [filter, setFilter] = useState('')

  const { mountpointsList } = useMountpointsList('', null)
  const { data } = useSystemLogs(logsQuery)

  const onSubmit = (data: any) => {
    const unixDate = (data.After as DateObject).toUnix()
    // console.log(logsQuery?.After === unixDate)
    // console.log(logsQuery?.Count === data.Count)
    // console.log(logsQuery?.Filter === data.Fitler)

    // if (
    //   logsQuery?.After === unixDate &&
    //   logsQuery?.Count === data.Count &&
    //   logsQuery?.Filter === data.Fitler
    // )
    //   return

    // setLoading(true)
    setLogsQuery({ ...data, After: unixDate })
  }

  useEffect(() => {
    if (data) {
      const strLines =
        typeof data === 'object' ? [JSON.stringify(data)] : data.split('\r\n').slice(0, -1)
      setStrLogs(strLines)
      setLogs(strLines.map((line) => JSON.parse(line)).sort((a, b) => b.ts - a.ts))
      // if (loading) setLoading(false)
    }
  }, [data])

  const serversList = mountpointsList?.map((item) => {
    return {
      label: item.name,
      value: item.name,
    }
  })

  const [filteredLogs, setFilteredLogs] = useState<any[]>([])

  useEffect(() => {
    if (logs.length !== strLogs.length) return
    const filtered: any[] = []
    strLogs.forEach((strLog, i) => {
      if (strLog.includes(filter)) filtered.push(logs[i])
    })
    setFilteredLogs(filtered)
  }, [filter, strLogs, logs])

  return (
    <Paper className={classes.paper}>
      <Typography className={classes.title}>{strings.systemLog}</Typography>
      <form onSubmit={handleSubmit(onSubmit)}>
        <GridContainer>
          <GridItem md={4} xl={3}>
            <DateInput
              label={strings.after}
              name="After"
              defaultValue={defaultDate}
              control={control}
              format={DATE_FORMAT}
              plugins={[
                <TimePicker onClick={(e) => e.preventDefault()} hideSeconds position="bottom" />,
              ]}
              clearIcon={false}
            />
          </GridItem>
          <GridItem md={3} xl={2}>
            <SelectInput
              label={strings.rowCount}
              name="Count"
              defaultValue={COUNT_OPTIONS[2].value}
              control={control}
              options={COUNT_OPTIONS}
            />
          </GridItem>
          <GridItem md={3} xl={2}>
            <SelectInput
              label={strings.serverFilter}
              name="Filter"
              control={control}
              options={serversList ?? []}
            />
          </GridItem>
          <GridItem md={1}>
            <Button
              // disabled={loading}
              type="submit"
              style={{ width: 50 }}
              variant="contained"
            >
              {strings.do}
              {/* {loading ? <CircularProgress size={25} /> : strings.do} */}
            </Button>
          </GridItem>
        </GridContainer>
      </form>
      <GridContainer>
        <GridItem md={10} xl={7}>
          <TextInput
            ref={filterRef}
            onKeyPress={(event: any) => {
              if (event.key === 'Enter' && filterRef.current?.value !== undefined)
                setFilter(filterRef.current?.value)
            }}
          />
        </GridItem>
        <GridItem md={1}>
          <Button
            onClick={() => {
              if (filterRef.current?.value !== undefined) setFilter(filterRef.current?.value)
            }}
            style={{ width: 50 }}
            variant="contained"
          >
            {strings.search}
          </Button>
        </GridItem>
      </GridContainer>

      <LogsList logs={filteredLogs} />

      {/* <div className={classes.divscroll}>
        <LogsList logs={filteredLogs} />
      </div> */}
    </Paper>
  )
}

// function LogsList({ logs }: { logs: any[] }) {
//   return (
//     <AutoSizer disableHeight>
//       {({ width }) => (
//         <List
//           width={width}
//           height={window.innerHeight - 260}
//           rowCount={logs.length}
//           rowHeight={30}
//           rowRenderer={({ index, key, style }) => (
//             <LogEntry log={logs[index]} index={index} key={key} style={style} />
//           )}
//         />
//       )}
//     </AutoSizer>
//   )
// }

// function LogEntry(props: any) {
//   const classes = useStyles()
//   const fields = keys(props.log).map((key) => ({ key, value: props.log[key] }))

//   let levelClass = classes.levelError
//   if (props.log.level === 'info') levelClass = classes.levelInfo
//   else if (props.log.level === 'warn') levelClass = classes.levelWarn

//   return (
//     <div
//       className={[classes.logEntry, levelClass].join(' ')}
//       style={props.style}
//       title={JSON.stringify(props.log, null, 2)}
//     >
//       <div>{props.index + 1}</div>
//       {fields.map((field) => (
//         <LogField field={field} key={field.key} />
//       ))}
//     </div>
//   )
// }

// function LogField({ field }: any) {
//   let value = field.value

//   if (field.key === 'ts') {
//     value = formatDate(new Date(value * 1000))
//   }

//   if (typeof value === 'object') {
//     return null
//   } else if (typeof value === 'boolean') {
//     value = value + ''
//   }

//   return (
//     <div style={{ whiteSpace: 'nowrap' }}>
//       {field.key}: {value}
//     </div>
//   )
// }
